import { ShieldCheck, Clock, RefreshCw, LogOut, MessageCircle } from "lucide-react";
import { BrandLogo } from "./BrandLogo";
import { useAuth } from "../context/AuthContext";

export default function PendingApproval() {
  const { user, logout, refresh } = useAuth();
  return (
    <div className="min-h-screen bg-[#F5F8FD] hero-bg flex items-center justify-center p-6">
      <div
        className="w-full max-w-lg bg-[#FFFFFF]/85 backdrop-blur-xl border border-slate-200 rounded-2xl p-7 text-center"
        data-testid="pending-approval-screen"
      >
        <BrandLogo size={72} className="mx-auto mb-4" />
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-amber-500/10 border border-amber-500/30 mb-3">
          <Clock className="w-7 h-7 text-amber-400" />
        </div>
        <h1 className="font-display text-2xl font-black text-slate-900 tracking-tighter">
          Warten auf Freischaltung
        </h1>
        <p className="text-sm text-slate-600 mt-3 leading-relaxed">
          Hallo <span className="text-slate-900 font-semibold">{user?.name}</span> 👋,
          dein Konto wurde erstellt. Bevor du in die Community schreiben kannst,
          muss ein Administrator dich freischalten.
        </p>

        {/* WhatsApp info — no link button */}
        <div className="mt-6 bg-emerald-500/10 border border-emerald-500/30 rounded-2xl p-5 text-left">
          <div className="flex items-center gap-2 text-emerald-300 text-xs font-bold uppercase tracking-wider mb-2">
            <MessageCircle className="w-4 h-4" /> Freischaltung nur über WhatsApp
          </div>
          <p className="text-sm text-slate-800 leading-relaxed">
            Die Freischaltung bekommst du <span className="font-semibold text-slate-900">nur</span>,
            wenn du dich beim WhatsApp-Agenten anmeldest.
            Schreib dem Agenten kurz auf WhatsApp – wir kümmern uns dann um deine Freischaltung.
          </p>
        </div>

        <div className="mt-4 text-xs uppercase tracking-[0.2em] text-[#4DBFFF] flex items-center justify-center gap-2">
          <ShieldCheck className="w-3.5 h-3.5" /> Sicherheits-Check durch Admin
        </div>

        <div className="flex flex-col sm:flex-row gap-2 mt-5">
          <button
            onClick={refresh}
            data-testid="pending-refresh-btn"
            className="flex-1 inline-flex items-center justify-center gap-2 bg-[#1D5BFF] hover:bg-[#1546C9] text-white font-bold py-3 rounded-full transition-all active:scale-95"
          >
            <RefreshCw className="w-4 h-4" /> Status prüfen
          </button>
          <button
            onClick={logout}
            data-testid="pending-logout-btn"
            className="flex-1 inline-flex items-center justify-center gap-2 bg-slate-100/70 hover:bg-slate-100 text-slate-900 font-semibold py-3 rounded-full transition-all"
          >
            <LogOut className="w-4 h-4" /> Abmelden
          </button>
        </div>
      </div>
    </div>
  );
}
